export default "__VITE_ASSET__50db0612__"